<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <v-row>
            <!-- Logo -->
            <v-col cols="12" md="2" class="text-right">
              <v-img
                src="@/assets/UM6PLOGO.png"
                contain
                max-height="50"
                max-width="150"
                class="mr-2"
              ></v-img>
            </v-col>

            <!-- Contenu principal -->
            <v-col cols="12" md="10">
              <div v-if="$storeUniversite.itemLang == 'lang00'">
                <h1 class="text-center" style="color: #d84a2b">
                  Création d'un compte candidat
                </h1>
                <h2 class="text-center">Votre compte a été créé avec succès</h2>
                <p class="text-center">
                  Vous allez recevoir un courriel avec un lien qui vous
                  permettra de créer votre mot de passe. Vous pourrez avec votre
                  compte commencer votre processus de candidature via votre
                  portail.
                </p>
              </div>
              <div v-else>
                <h1 class="text-center" style="color: #d84a2b" >Candidate Account Creation</h1>
    <h2 class="text-center">Your account has been created successfully.</h2>
    <p class="text-center">
      You will receive an email with login details and a link to create your
      password. Once done, You will be able to start you application process via
      your own candidate portal.
    </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  // Votre logique de composant si nécessaire
};
</script>

<style scoped>
/* Vos styles CSS spécifiques à ce composant si nécessaire */
</style>
